/* eslint-disable no-underscore-dangle */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Grid, MenuItem, FormControl, Select, InputLabel } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import MarketPlace from './MarketPlace';
import { retrieveMarketplaceInclusionsExclusions } from '../../../shared/utils/helpers';
import { getMaxTicketsQty, getEffectiveGroupSplitType } from '../../../helpers/pricing';
import CustomSplit from './CustomSplit';
import AdvancedSettingsFooter from '../../../components/KillshotGroups/AdvancedSettings/footer';

const styles = makeStyles({
  formControl: {
    width: '140px',
  },
  splitContainer: {
    marginTop: '15px',
  },
});

const GroupAdvanceSettings = props => {
  const {
    group,
    index,
    handleMarketModalSubmit,
    handleMarketModalClose,
    marketplaces,
    handleMarketplaceChange,
    handleGroupAttrEdit,
    groupedListings,
  } = props;
  const classes = styles();
  const includeExclude = retrieveMarketplaceInclusionsExclusions(marketplaces);
  const [inclusions, setInclusions] = useState(includeExclude.inclusions);
  const [exclusions, setExclusions] = useState(includeExclude.exclusions);
  const maxFromListings = getMaxTicketsQty(group, groupedListings);
  const maxQty = Math.max(maxFromListings, 1);
  const splitType = getEffectiveGroupSplitType(group);

  const handleMarketModalSetCriteria = () => {
    handleMarketplaceChange(index, inclusions, exclusions);
    handleMarketModalClose();
  };

  const handleModalClose = () => {
    setInclusions(includeExclude.inclusions);
    setExclusions(includeExclude.exclusions);
    handleMarketModalClose();
  };

  return (
    <form autoComplete="off" onSubmit={handleMarketModalSubmit}>
      <Grid container>
        <Grid item xs={8}>
          <span>Broadcasting is turned on for all selected marketplaces.</span>
          <MarketPlace
            marketplaces={marketplaces}
            pricingGroupID={group.id}
            includeExclude={includeExclude}
            inclusions={inclusions}
            setInclusions={setInclusions}
            exclusions={exclusions}
            setExclusions={setExclusions}
          />
        </Grid>
        <Grid item xs={4}>
          <Grid container className={classes.pricingFlexContainer}>
            <Grid item xs={12} className={classes.splitContainer}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Sellable Quantity
                </InputLabel>
                <Select
                  value={splitType || null}
                  onChange={handleGroupAttrEdit('split_type', null)}
                  inputProps={{
                    name: 'split_type',
                    id: 'split_type',
                  }}
                >
                  <MenuItem value="CUSTOM">Custom</MenuItem>
                  <MenuItem value="ANY">Any</MenuItem>
                  <MenuItem value="NEVERLEAVEONE">Never Leave One</MenuItem>
                  <MenuItem value="DEFAULT">Default</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            {splitType === 'CUSTOM' && (
              <CustomSplit group={group} handleGroupAttrEdit={handleGroupAttrEdit} quantity={maxQty} />
            )}
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.footerMessage} style={{ marginTop: '15px' }}>
        <Grid item xs={12}>
          <span>
            Please make sure to save the group after you SET CRITERIA in order for your selections to be saved.
          </span>
        </Grid>
      </Grid>
      <AdvancedSettingsFooter handleModalClose={handleModalClose} handleSetCriteria={handleMarketModalSetCriteria} />
    </form>
  );
};

GroupAdvanceSettings.propTypes = {
  handleMarketModalSubmit: PropTypes.func.isRequired,
  handleMarketModalClose: PropTypes.func.isRequired,
  handleMarketplaceChange: PropTypes.func.isRequired,
  group: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  marketplaces: PropTypes.object.isRequired,
  handleGroupAttrEdit: PropTypes.func.isRequired,
  groupedListings: PropTypes.array.isRequired,
};

export default GroupAdvanceSettings;
